
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { singularityStore, uiStore } from "@/store/store";
import SingularityCanvasButton from "./SingularityCanvasButton.vue";
import { TreeNode } from "@/types/tree";

@Component({
  components: {
    SingularityCanvasButton
  }
})
export default class EditSectionButton extends Vue {
  @Prop()
  elementId!: TreeNode["id"];

  activateElement() {
    uiStore.activateElement(this.elementId);
    singularityStore.setSingularityLeftPanel("page_structure");
  }
}
